/**
 * Format Money Helper
 */
function formatMoney(cents) {
  return '£' + (cents / 100).toFixed(2);
}

/**
 * Main Logic: Recalculate Totals & Update UI
 */
window.recalcBulkTotals = function() {
  const container = document.querySelector('[data-bulk-matrix]');
  if (!container) return;

  const basePriceCents = parseInt(container.getAttribute('data-base-price')) || 0;
  
  // 1. BULLETPROOF VAT DETECTION: Check what the main Unit Price is currently displaying
  let isIncVat = true;
  const unitPriceContainer = document.querySelector('.bm-unit-price.price__container');
  if (unitPriceContainer) {
    const unitPriceDisplay = document.getElementById('bm-base-price-display');
    // If the visible text matches the EX VAT data attribute, the toggle is set to Ex VAT
    if (unitPriceDisplay && unitPriceDisplay.innerText === unitPriceContainer.getAttribute('data-price')) {
      isIncVat = false;
    }
  }

    let totalQty = 0;
  let subtotalCents = 0;
    let minVisibleUnitCents = null;
  let firstVisibleUnitCents = null;
  
  // LOOP THROUGH INPUTS AND SET BUTTON STATES & ROW TOTALS
  document.querySelectorAll('[data-bulk-input]').forEach(input => {
    if (input.offsetParent !== null) { // Only count visible inputs
      let qty = parseInt(input.value) || 0;
      const maxVal = parseInt(input.getAttribute('max')) || 9999;
      
      if (qty > maxVal) { qty = maxVal; input.value = maxVal; }
      if (qty < 0) { qty = 0; input.value = 0; }
      
      totalQty += qty;
      
      // Update Row Highlight
      const row = input.closest('.bm-size-row');
      if (row) {
        if (qty > 0) row.classList.add('has-qty');
        else row.classList.remove('has-qty');
      }

      // --- CALCULATE INDIVIDUAL ROW TOTALS & VAT COMPATIBILITY ---
      const unitPriceCents = parseInt(input.getAttribute('data-unit-price')) || basePriceCents;
            const lineTotalCents = qty * unitPriceCents;
            subtotalCents += lineTotalCents;
      if (firstVisibleUnitCents === null) firstVisibleUnitCents = unitPriceCents;
      if (minVisibleUnitCents === null || unitPriceCents < minVisibleUnitCents) {
        minVisibleUnitCents = unitPriceCents;
      }
      const lineTotalExVatCents = lineTotalCents / 1.20;

      const rowTotalWrapper = row ? row.querySelector('.bm-row-total') : null;

      if (rowTotalWrapper) {
        // 1. Update the outer wrapper
        rowTotalWrapper.setAttribute('data-price', formatMoney(lineTotalExVatCents));
        rowTotalWrapper.setAttribute('data-price-vat', formatMoney(lineTotalCents));
        
        // 2. FORCE update all inner spans (This fixes the £0.00 VAT toggle bug)
        const innerSpans = rowTotalWrapper.querySelectorAll('.price__container, .money');
        innerSpans.forEach(span => {
          span.setAttribute('data-price', formatMoney(lineTotalExVatCents));
          span.setAttribute('data-price-vat', formatMoney(lineTotalCents));
        });

        // 3. Instantly update the visible text based on current VAT state
        const rowTotalVal = rowTotalWrapper.querySelector('.bm-row-total-val');
        if (rowTotalVal) {
          rowTotalVal.innerText = isIncVat ? formatMoney(lineTotalCents) : formatMoney(lineTotalExVatCents);
        }

        // Show or hide the row total
        rowTotalWrapper.style.opacity = qty > 0 ? '1' : '0';
      }

      // UPDATE MINUS/PLUS BUTTON STATES
      const qtyContainer = input.closest('.bm-size-qty');
      const minusBtn = qtyContainer.querySelector('[data-bulk-minus]');
      const plusBtn = qtyContainer.querySelector('[data-bulk-plus]');
      
      if (minusBtn) minusBtn.disabled = (qty <= 0);
      if (plusBtn) plusBtn.disabled = (qty >= maxVal);
    }
  });

  // --- DISCOUNT LOGIC & PROGRESS BAR ---
  let discountPercent = 0;
  let nextThreshold = 10;
  let progressWidth = 0;

  const node10 = document.getElementById('node-10');
  const node25 = document.getElementById('node-25');
  const node50 = document.getElementById('node-50');

  if(node10) node10.classList.remove('is-active');
  if(node25) node25.classList.remove('is-active');
  if(node50) node50.classList.remove('is-active');

 if (totalQty >= 51) {
    // Fill the remaining tail end of the bar for 51+ items
    discountPercent = 0.15;
    nextThreshold = null;
    progressWidth = 100;
    if(node10) node10.classList.add('is-active');
    if(node25) node25.classList.add('is-active');
    if(node50) node50.classList.add('is-active');
  } else if (totalQty === 50) {
    // Stop exactly on the new 93% milestone for exactly 50 items
    discountPercent = 0.15;
    nextThreshold = null;
    progressWidth = 93; 
    if(node10) node10.classList.add('is-active');
    if(node25) node25.classList.add('is-active');
    if(node50) node50.classList.add('is-active');
  } else if (totalQty >= 25) {
    discountPercent = 0.10; 
    nextThreshold = 50;
    // Math to scale the bar between 50% and 93% (a 43% gap)
    progressWidth = 50 + ((totalQty - 25) / 25) * 43; 
    if(node10) node10.classList.add('is-active');
    if(node25) node25.classList.add('is-active');
  } else if (totalQty >= 10) {
    discountPercent = 0.05;
    nextThreshold = 25;
    // Math to scale the bar between 20% and 50% (a 30% gap)
    progressWidth = 20 + ((totalQty - 10) / 15) * 30; 
    if(node10) node10.classList.add('is-active');
  } else {
    discountPercent = 0;
    nextThreshold = 10;
    // Math to scale the bar between 0% and 20%
    progressWidth = (totalQty / 10) * 20; 
  }

  // Update Progress Fill
  const fill = document.getElementById('bm-discount-fill');
  const hint = document.getElementById('bm-discount-hint');
  
  if (fill) fill.style.width = `${progressWidth}%`;
  
  if (hint) {
    if (nextThreshold) {
      hint.innerText = `Order ${nextThreshold - totalQty} more for next price reduction`;
    } else {
      hint.innerText = `Maximum bulk discount reached!`;
    }
  }

  // --- PRICING MATH ---
    const totalPriceCents = subtotalCents;
  const discountAmountCents = totalPriceCents * discountPercent;
  const finalPriceCents = totalPriceCents - discountAmountCents;

  // --- UI UPDATES & VAT LOGIC ---
  const countEl = document.getElementById('bm-sb-count');
  const badgeEl = document.getElementById('bm-sb-badge');
  const originalEl = document.getElementById('bm-sb-original');
  const finalEl = document.getElementById('bm-sb-final');
  const checkoutBtn = document.getElementById('bm-checkout-btn');
  const checkoutText = document.getElementById('bm-checkout-text');

  // 2. Calculate Ex. VAT values (Dividing by 1.20)
  const finalPriceExVatCents = finalPriceCents / 1.20;
  const totalPriceExVatCents = totalPriceCents / 1.20;

  // 3. Update Hidden Data Attributes for Summary Bar
  const originalContainer = document.getElementById('bm-sb-original-container');
  const finalContainer = document.getElementById('bm-sb-final-container');

  if(originalContainer) {
    originalContainer.setAttribute('data-price', formatMoney(totalPriceExVatCents));
    originalContainer.setAttribute('data-price-vat', formatMoney(totalPriceCents));
  }
  if(finalContainer) {
    finalContainer.setAttribute('data-price', formatMoney(finalPriceExVatCents));
    finalContainer.setAttribute('data-price-vat', formatMoney(finalPriceCents));
  }

  // 4. Also update the "Unit Price" element if the discount changes it!
  const unitPriceDisplay = document.getElementById('bm-base-price-display');
  
  if (unitPriceContainer && unitPriceDisplay) {
                    let currentUnitCents = firstVisibleUnitCents !== null ? firstVisibleUnitCents : basePriceCents;
     if (totalQty > 0) {
        currentUnitCents = (subtotalCents / totalQty) * (1 - discountPercent);
     }
     const unitExVatCents = currentUnitCents / 1.20;
     
     unitPriceContainer.setAttribute('data-price', formatMoney(unitExVatCents));
     unitPriceContainer.setAttribute('data-price-vat', formatMoney(currentUnitCents));
     unitPriceDisplay.innerText = isIncVat ? formatMoney(currentUnitCents) : formatMoney(unitExVatCents);
  }

  // 5. Update visible text for Summary Bar
  if (countEl) countEl.innerText = `${totalQty} Items Selected`;
  if (finalEl) finalEl.innerText = isIncVat ? formatMoney(finalPriceCents) : formatMoney(finalPriceExVatCents);

  if (discountPercent > 0) {
    if (badgeEl) {
      badgeEl.innerText = `${discountPercent * 100}% off`;
      badgeEl.style.display = 'inline-block';
    }
    if (originalEl) {
      originalEl.innerText = isIncVat ? formatMoney(totalPriceCents) : formatMoney(totalPriceExVatCents);
      originalEl.style.display = 'inline-block';
    }
  } else {
    if (badgeEl) badgeEl.style.display = 'none';
    if (originalEl) originalEl.style.display = 'none';
  }

  // 6. Update Checkout Button
  if (totalQty > 0) {
    if(checkoutBtn) {
      checkoutBtn.classList.remove('is-disabled');
      checkoutBtn.classList.add('is-active');
      checkoutBtn.disabled = false;
    }
    
    // Create the formatted strings
    const incVatStr = formatMoney(finalPriceCents);
    const exVatStr = formatMoney(finalPriceExVatCents);
    const displayPrice = isIncVat ? incVatStr : exVatStr;
    
    // Inject the price wrapped in the global VAT classes so the toggle script can find it!
    if(checkoutText) {
      checkoutText.innerHTML = `Add Logo / Checkout <span class="pipe-symbol-add-log"> | </span><span> ${totalQty} Items - </span><span class="price__container" data-price="${exVatStr}" data-price-vat="${incVatStr}"><span class="price-item--regular">${displayPrice}</span></span>`;
    }
  } else {
    if(checkoutBtn) {
      checkoutBtn.classList.add('is-disabled');
      checkoutBtn.classList.remove('is-active');
      checkoutBtn.disabled = true;
    }
    if(checkoutText) checkoutText.innerText = `Add Logo / Checkout`;
  }
}

/**
 * Event Listeners
 */
document.addEventListener('click', (e) => {
  const plusBtn = e.target.closest('[data-bulk-plus]');
  if (plusBtn && !plusBtn.disabled) {
    const input = plusBtn.closest('.bm-size-qty').querySelector('[data-bulk-input]');
    const maxVal = parseInt(input.getAttribute('max')) || 9999;
    if (Number(input.value) < maxVal) {
      input.value = Number(input.value) + 1;
      window.recalcBulkTotals();
    }
    return;
  }

  const minusBtn = e.target.closest('[data-bulk-minus]');
  if (minusBtn && !minusBtn.disabled) {
    const input = minusBtn.closest('.bm-size-qty').querySelector('[data-bulk-input]');
    input.value = Math.max(0, Number(input.value) - 1);
    window.recalcBulkTotals();
    return;
  }
});

document.addEventListener('input', (e) => {
  if (e.target.matches('[data-bulk-input]')) {
    window.recalcBulkTotals();
  }
});

// FORCE POP-UP TO OPEN ON CHECKOUT CLICK (WITH !IMPORTANT OVERRIDE)
document.addEventListener('click', (e) => {
  const checkoutBtn = e.target.closest('#bm-checkout-btn');
  if (checkoutBtn && !checkoutBtn.disabled) {
    e.preventDefault(); 
    e.stopPropagation(); // Block other scripts from interfering
    
    // 1. Try to open via the external function if it exists
    if (typeof window.pcOpenModal === 'function') {
      window.pcOpenModal();
    } 

    // 2. Forcefully override styles to beat the !important inline rules we added to stop the flash
    const modal = document.getElementById('lp-modal-wrapper') || 
                  document.getElementById('pc-modal-wrapper') || 
                  document.getElementById('bm-conf-modal');
                  
    if (modal) {
      modal.style.setProperty('display', 'block', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      modal.style.setProperty('opacity', '1', 'important');
      modal.style.setProperty('pointer-events', 'auto', 'important');
      
      modal.classList.remove('pc-hidden', 'lp-hidden', 'bm-conf-hidden');
      document.body.classList.add('pc-scroll-lock', 'bm-modal-open');
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  window.recalcBulkTotals();
});